// extracted by mini-css-extract-plugin
export default {"nav":"LandingPage_nav__IDk0w","holdImage":"LandingPage_holdImage__-fr3Q","holdImage1":"LandingPage_holdImage1__jI7IU","imageNow":"LandingPage_imageNow__jLjY0"};